<template>
  <div id="login2">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>

      <img
        class="w-100 d-block d-lg-none"
        src="../assets/imgs/foroprosa2024/foro2024_header_mobile.jpg"
        alt="Foro Prosa"
      />
      <img
        class="w-100 d-none d-lg-block"
        src="../assets/imgs/foroprosa2024/foro2024_header_desk.jpg"
        alt="Foro Prosa"
      />

      <div class="container pb-5">
        <!-- <div class="row pt-5">
          <div class="col-12">
            <b-carousel
              id="carousel-fade"
              style="text-shadow: 0px 0px 2px #000"
              fade
              indicators
              img-width="1024"
              img-height="480"
            >
              <b-carousel-slide
                caption=""
                :img-src="require('../assets/imgs/foroprosa/slides/Slider_home01.jpg')"
              ></b-carousel-slide>

              <b-carousel-slide
                caption=""
                :img-src="require('../assets/imgs/foroprosa/slides/Slider_home_bienvenidos.jpg')"
              ></b-carousel-slide>

              <b-carousel-slide
                caption=""
                :img-src="require('../assets/imgs/foroprosa/slides/Slider_hero_evento.jpg')"
              ></b-carousel-slide>

              <b-carousel-slide
                caption=""
                :img-src="require('../assets/imgs/foroprosa/slides/Slider_PLENARIA.jpg')"
              ></b-carousel-slide>
              
            </b-carousel>
          </div>
        </div> -->

        <div class="row">
          <div class="col-12 pt-md-5">
            <div class="row d-flex justify-content-center align-items-center">
              <div class="col-9">
                <div class="fG2 pb-2 bold">
                  20 &bull; SEP &bull; 2024 &bull; 08:30 hrs
                </div>
                <div class="separador mb-2"></div>
                <div class="fG bold">
                  Hotel Camino Real Polanco, Terraza Virreyes
                </div>
                <div>
                  <a
                    href="https://goo.gl/maps/MWsqZWbZLib6C9op9"
                    target="_blank"
                    >Ver mapa &raquo;</a
                  >
                </div>
              </div>
              <div class="col-3">
                <img
                  src="../assets/imgs/foroprosa2024/fecha-22-sep-2024.png"
                  alt="Foro Prosa"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class=" col-lg-12 offset-lg-0 mt-5"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <div class="row p-3">
              <div class="col-12 col-lg-6 mb-4">
                <div class="bg24 esqbotder p-3 shadow">
                  <router-link to="/agenda" class="row no-gutters">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-9 offset-2">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa/home/info.png"
                            alt="Foro Prosa"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center centeredxy morado">
                      <span class="fXG">
                        Agenda
                      </span>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="col-12 col-lg-6 mb-4">
                <div class="bg24 esqbotizq p-3 shadow">
                  <router-link to="/ponentes" class="row no-gutters">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-9 offset-2">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa/home/ponentes.png"
                            alt="Foro Prosa"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center centeredxy morado">
                      <span class="fXG"> Ponentes </span>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="col-12 col-lg-6 mb-4">
                <div class="bg24 esqtopder p-3 shadow">
                  <router-link to="/mapa" class="row no-gutters">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-9 offset-2 text-center">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa/home/mapa.png"
                            alt="Foro Prosa"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center centeredxy morado">
                      <span class="fXG"> Stands </span>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="col-12 col-lg-6 mb-4">
                <div class="bg24 esqtopizq p-3 shadow">
                  <router-link to="/faqs" class="row no-gutters">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-9 offset-2 text-center">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa/home/pregunta.png"
                            alt="Foro Prosa"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center centeredxy morado">
                      <span class="fXG"> FAQs </span>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="col-12 col-lg-6 mb-4">
                <div class="bg24 esqtopder p-3 shadow">
                  <router-link to="/patrocinadores" class="row no-gutters">
                    <div class="col-5">
                      <div class="row">
                        <div class="col-9 offset-2 text-center">
                          <img
                            class="img-fluid"
                            src="../assets/imgs/foroprosa/home/info.png"
                            alt="Foro Prosa"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-7 text-center centeredxy morado">
                      <span class="fXG"> Patrocinadores </span>
                    </div>
                  </router-link>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

export default {
  components: {
    Footer,
    SiteNav,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      slides: null,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }

    let slides_temp = this.shuffle(this.$store.state.slides);

    this.slides = [
      slides_temp[0],
      slides_temp[1],
      slides_temp[2],
      slides_temp[3],
    ];
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    shuffle(array) {
      array.sort(() => Math.random() - 0.5);
      return array;
    },
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = {
        no_cliente: this.loginForm.no_cliente,
        email: this.loginForm.email,
        password: this.loginForm.password,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "login2.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              localStorage.setItem(
                "user_foroprosa_2023",
                JSON.stringify(res.usuario)
              );

              router.push("/");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        telefono: "",
        movil: "",
        ext: "",
        terminos: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_guantes = "";
      }
    },
    quitarAcentos(elemento) {
      //console.log('quitando acentos')
      elemento = elemento.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      //console.log({elemento})
      return elemento;
    },
  },
};
</script>
